export default `query getCarrierList($limit: Int, $offset: Int, $keyword: String $status: StatusType){
  getCarrierList(limit: $limit, offset: $offset, keyword: $keyword status: $status) {
    count
    data {
      id
      name
    }
  }
}`;
